/**
 * 激活码批次日志 — read-only list of distribution batches.
 *
 * Shows admin audit trail: who distributed, which token, how much, how many users.
 */
import { useState } from 'react';
import { Input, Select, Space, Tag } from 'antd';
import { DataTable } from '../../components/DataTable';

interface BatchRow {
  id: number;
  admin_id: number;
  token: string;
  amount: string;
  user_count: number;
  total_amount: string;
  note: string | null;
  create_time: string;
}

const TOKEN_OPTIONS = [
  { label: 'All Tokens', value: '' },
  { label: 'RP', value: 'rp' },
  { label: 'TP', value: 'tp' },
  { label: 'EP', value: 'ep' },
];

const TOKEN_COLORS: Record<string, string> = {
  rp: 'blue',
  tp: 'green',
  ep: 'orange',
};

export function ActivationBatchPage() {
  const [token, setToken] = useState('');
  const [adminId, setAdminId] = useState('');

  const extra: Record<string, string> = {};
  if (token) extra.token = token;
  if (adminId) extra.admin_id = adminId;

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Admin', dataIndex: 'admin_id', width: 80 },
    {
      title: 'Token',
      dataIndex: 'token',
      width: 80,
      render: (v: string) => <Tag color={TOKEN_COLORS[v] ?? 'default'}>{v.toUpperCase()}</Tag>,
    },
    { title: 'Per-User Amount', dataIndex: 'amount', width: 140 },
    { title: 'User Count', dataIndex: 'user_count', width: 100 },
    { title: 'Total Amount', dataIndex: 'total_amount', width: 160 },
    { title: 'Note', dataIndex: 'note', ellipsis: true },
    {
      title: 'Created',
      dataIndex: 'create_time',
      width: 180,
      render: (v: string) => v?.slice(0, 19).replace('T', ' '),
    },
  ];

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 140 }}
          options={TOKEN_OPTIONS}
          value={token}
          onChange={setToken}
        />
        <Input
          placeholder="Admin ID"
          allowClear
          style={{ width: 120 }}
          value={adminId}
          onChange={(e) => setAdminId(e.target.value)}
        />
      </Space>

      <DataTable<BatchRow>
        queryKey={['admin', 'activation', 'batches', token, adminId]}
        endpoint="/admin/activation/batches"
        extraParams={extra}
        columns={columns}
        rowKey="id"
      />
    </>
  );
}
